import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {Agency} from "../Models/Agency";
import {EMPTY, Observable, of, throwError} from "rxjs";
import {catchError} from "rxjs/operators";
import {UserMinAdmin} from "../Models/UserMinAdmin";
import {SiteKeyEnum} from "../enums/site-key.enum";
import {ContactV2} from "../Models/ContactV2";
import {ApiV2ErrorCodes, hasApiV2ErrorCode} from "../const/api-v2-error-codes";

@Injectable({
	providedIn: 'root'
})
export class ApiToolsService {
	//authToken: any;


	constructor(
		private http: HttpClient
	) {
	}

	getAuthToken() {
		return JSON.parse(localStorage.getItem("token")!);
	}

	getHeaders() {
		let authToken = this.getAuthToken();
		return new HttpHeaders().set(
			'Authorization',
			authToken?.token_type + ' ' + authToken?.token
		);
	}

	getHeadersV2() {
		let authToken = this.getAuthToken();
		return new HttpHeaders().set(
			'Authorization',
			authToken?.token_type + ' ' + authToken?.token_v2
		);
	}

	//===================================================================== Coonexion
	loginUsr(Login: string, Password: string) {
		return this.http.post<any>(environment.usrCtrl.login, {Login, Password});
	}

	loginUsrByGuid(Guid: string) {
		return this.http.post<any>(environment.usrCtrl.login, {Guid});
	}

	validUsrByUuid(uuid: string) {
		return this.http.post<any>(environment.usrCtrl.validationByUuid, {uuid});
	}

	tokenValidation(referer: string, _token: string) {
		switch (referer) {
			case SiteKeyEnum.CADASTRE:
				return this.http.post<any>(environment.cadastreCtrl.jwtTokenValidation, {token: _token});
			default:
				console.log(referer + " not found !");
				return EMPTY;
		}
	}

	subValidation(referer: string, _sub: string) {
		switch (referer) {
			case SiteKeyEnum.CADASTRE:
				return this.http.post<any>(environment.cadastreCtrl.checkSubscription, {sub: _sub});
			default:
				console.log(referer + " not found !");
				return EMPTY;
		}
	}

	//==================================================================== Mot de pass oublie
	forgotPassword(Email: string) {
		return this.http.post(environment.usrCtrl.passwordReminder, {Email});
	}

	getAllDataRef(_tabCode: string) {
		return this.http.get(environment.dataRefCtrl.getAllDataRef.replace("{TabCode}", _tabCode));
	}

	//=================================================================== Get User By Id
	getUserID() {
		let authToken = this.getAuthToken();
		return this.http.get(environment.usrCtrl.getUserById + "?ItemId=" + authToken?.userId, {headers: this.getHeaders()});
	}

	getUserDtoAltById(_usrId: number) { // ==> Get User By Id
		return this.http.get(environment.usrCtrl.getUserDtoAltById + "?ItemId=" + _usrId, {headers: this.getHeaders()});
	}

	getUserDtoAltByIdAdmin(_usrId: number) { // ==> Get User By Id Role Admin
		return this.http.get(environment.usrCtrl.getUserDtoAltByIdAdmin + "?UserId=" + _usrId, {headers: this.getHeaders()});
	}

	updateUserDtoAlt(_user: any) {	// ==> Update UserDtoAlt
		return this.http.post(environment.usrCtrl.updateUserDtoAlt, _user, {headers: this.getHeaders()});
	}

	updateUserDtoAltAdmin(_user: any) {	// ==> Update UserDtoAlt Role Admin
		return this.http.post(environment.usrCtrl.updateUserDtoAltAdmin, _user, {headers: this.getHeaders()});
	}

	inscription(_user: any) { // ==> Add UserDtoAlt
		return this.http.post(environment.usrCtrl.inscription, _user)
	}

	addUserDtoAlt(_user: any, _sendmail: number) {	// ==> Add UserDtoAlt
		return this.http.post(environment.usrCtrl.addUserDtoAlt + '?SendMail=' + _sendmail, _user, {headers: this.getHeaders()});
	}

	addUserDtoAltAdmin(_user: any, _sendmail: number) {	// ==> Add UserDtoAlt
		return this.http.post(environment.usrCtrl.addUserDtoAltAdmin + '?SendMail=' + _sendmail, _user, {headers: this.getHeaders()});
	}

	updatePassword(_oldPassword: string, _newPassword: string) {	// ==> Update Password
		let params = {
			OldPassword: _oldPassword,
			NewPassword: _newPassword
		};
		return this.http.post(environment.usrCtrl.updatePassword, params, {headers: this.getHeaders()});
	}

	// ==> Delete UserDtoAlt
	delUserDtoAlt(_userId: number) {
		return this.http.delete(environment.usrCtrl.delUserDtoAlt + "?ItemId=" + _userId, {
			headers: this.getHeaders()
		});
	}

	// ==> Validate Code Referer
	validateCodeReferer(_code: string) {
		return this.http.get(environment.usrCtrl.validateCodeReferer + "?Code=" + _code);
	}

	getAllUsersAltByUsrId(_usrId: number, _typeId: number) {	// ==> Get All Users Alt By UsrId
		return this.http.get(environment.usrCtrl.getAllUsersAltByUsrId + "?UsrId=" + _usrId + "&TypeId=" + _typeId, {headers: this.getHeaders()});
	}

	// ==> Get All Organisations By UsrId
	getAllOrganisationsByUsrId(_usrId: number) {	// ==> Get All Organisations By UsrId
		return this.http.get(environment.orgCtrl.getAllOrganisationsByUsrId + "?UsrId=" + _usrId, {headers: this.getHeaders()});
	}

	// ==> Get Organisation By Id
	getOrganisationById(_orgId: number) {
		return this.http.get(environment.orgCtrl.getOrganisationById + "?ItemId=" + _orgId, {headers: this.getHeaders()});
	}

	// ==> Set Organisation
	setOrganisation(_org: Agency) {
		return this.http.post(environment.orgCtrl.setOrganisation, _org, {headers: this.getHeaders()});
	}

	// ==> Delete Organisation
	delOrganisation(_orgId: number) {
		return this.http.delete(environment.orgCtrl.delOrganisation + "?ItemId=" + _orgId, {headers: this.getHeaders()});
	}

	// TODO: CHange to real API
	getSimIdByUuidFake(simUuid : number) {
		return of(85801);
	}

	getSimIdBySimUuid(simUuid : string) {
		return this.http.get(environment.simulationsCtrl.getByUuid.replace("{uuid}", simUuid), {headers: this.getHeadersV2()});
	}

	// ==> Attach the simulation to the user of the v2 token, and save the contact in SIN_ASSURE_* (API v2)
	changeSimulationUser(simUuid: string, contact: ContactV2): Observable<any> {
		return this.http.patch(environment.simulationsCtrl.changeUser.replace("{uuid}", simUuid), contact, {headers: this.getHeadersV2()});
	}

	//===================================================================== Users (API v2)
	// ==> Search a user by email (UserDto), returns null if not found (USER_EMAIL_NOT_EXISTS)
	getUserByEmail(email: string): Observable<any> {
		return this.http.get(environment.usersCtrl.getByEmail.replace("{email}", encodeURIComponent(email)), {headers: this.getHeadersV2()})
			.pipe(catchError(err => hasApiV2ErrorCode(err, ApiV2ErrorCodes.USER_EMAIL_NOT_EXISTS)
				? of(null)
				: throwError(err)));
	}

	// ==> Create a user in the referential of the v2 token (UserDto)
	createUser(contact: ContactV2): Observable<any> {
		return this.http.post(environment.usersCtrl.create, contact, {headers: this.getHeadersV2()});
	}

	// ==> Add a used simulation to the user of the v2 token
	trialSimulationUsed(simUuid: string): Observable<any> {
		return this.http.patch(environment.simulationsCtrl.trialSimulationUsed.replace("{SIM_UUID}", simUuid), {}, {headers: this.getHeadersV2()});
	}

	getSinistreByID(simId: number, minVersion: boolean = false) {
		let route = (!minVersion)
			? environment.sinCtrl.getSimulationById + "?SIM_ID=" + simId.toString()
			: environment.sinCtrl.simulationPieceMinGet.replace("{SIM_ID}", simId.toString());

		return this.http.get(route, {headers: this.getHeaders()});
	}

	getAllSimulationByUsrId(_userId: number) {
		return this.http.get(environment.sinCtrl.getAllSimulationByUsrId
				.replace("{usrId}", _userId.toString()),
			{headers: this.getHeaders()});
	}

	deleteSimulationById(_itemId: number) {
		return this.http.get(environment.sinCtrl.deleteSimulationById.replace("{itemId}", _itemId.toString()),
			{headers: this.getHeaders()});	// ==> Delete Simulation By Id
	}

	getSimulationByUsrId(_usrId?: number) {
		let authToken = this.getAuthToken();
		let usrId = (_usrId) ? _usrId : authToken?.userId;
		return this.http.get(environment.sinCtrl.getSimulationByUsrId + "?UsrId=" + usrId.toString(), {headers: this.getHeaders()});
	}

	// ==> Get Simulation presta/pièce
	getSimulationParamsById(_sinId: number) {
		return this.http.get(environment.sinCtrl.getSimulationParamsById.replace("{SIN_ID}", _sinId.toString()), {headers: this.getHeaders()});
	}

	// ==> Set Simulation presta/pièce
	setSimulationParamsById(_sinId: number, _list: any) {
		return this.http.post(environment.sinCtrl.setSimulationParamsById.replace("{SIN_ID}", _sinId.toString()), {list: _list}, {headers: this.getHeaders()});
	}

	getSimulationEstimation(_simId: string) {
		return this.http.get(environment.sinCtrl.getSimulationEstimation.replace("{SIM_ID}", _simId), {headers: this.getHeaders()});
	}

	getSimulationEncart(_simId: string) {
		return this.http.get(environment.sinCtrl.getSimulationEncart.replace("{SIM_ID}", _simId), {headers: this.getHeaders()});
	}

	// ==> Get Simulation presta/pièce
	getElementsByIdMere(_cmoIdMere: number) {
		return this.http.get(environment.ElmCtrl.getElementsByIdMere.replace("{CMO_ID_MERE}", _cmoIdMere.toString()), {headers: this.getHeaders()});
	}

	// ==> Get Simulation presta/pièce
	getElementsCuiByIdMere(_cmoIdMere: number) {
		return this.http.get(environment.ElmCtrl.getElementsCuisineGet.replace("{CMO_ID_MERE}", _cmoIdMere.toString()), {headers: this.getHeaders()});
	}

	getSrfRfsDmgGet(_picId: number) {
		return this.http.get(environment.ElmCtrl.getSrfRfsDmgGet.replace("{PIC_ID}", _picId.toString()), {headers: this.getHeaders()});
	}

	getMobGroupByScaGet(_picId: number) {
		return this.http.get(environment.ElmCtrl.getMobGroupByScaGet.replace("{PIC_ID}", _picId.toString()), {headers: this.getHeaders()});
	}

	// ==> SET (create and edit) mobilier
	setMobMobilierSet(_mobMobilier: any) {
		return this.http.post(environment.ElmCtrl.setMobMobilierSet, _mobMobilier, {headers: this.getHeaders()});
	}

	// ==> DELETE mobilier
	delMobMobilierDel(_mobMobilier: any, _mobId: any) {
		return this.http.post(environment.ElmCtrl.delMobMobilierDel, {
			Mobilier: _mobMobilier,
			MOB_ID: _mobId
		}, {headers: this.getHeaders()});
	}

	// ==> SET (create and edit) presta
	setStpStatuePrestaSet(_stpStatut: any) {
		return this.http.post(environment.ElmCtrl.setStpStatuePrestaSet, _stpStatut, {headers: this.getHeaders()});
	}

	// ==> Sauvegarde DMG et SRF by PIC ?
	setDmgModernisationSet(_listSrfRenovation: any) {
		return this.http.post(environment.ElmCtrl.setDmgModernisationSet, {list: _listSrfRenovation}, {headers: this.getHeaders()});
	}

	// ==> Pour les pieces
	generateSimulationByParam(_params: any) {
		return this.http.post(environment.sinCtrl.generateSimulationByParam, _params, {headers: this.getHeaders()});
	}

	// ==> Pour la creation des surfaces et mobilier
	generationSurfaceEtMobilierSimulation(_sinId: number) {
		return this.http.get(environment.sinCtrl.generationSurfaceEtMobilierSimulation.replace("{SIM_ID}", _sinId.toString()), {headers: this.getHeaders()});
	}

	// ==> UPDATE Simulation écran PIÈCES
	simulationPieceMinUpdate(_list: any, _simId: number) {
		return this.http.post(environment.sinCtrl.simulationPieceMinUpdate + "?SIM_ID=" + _simId.toString(), {list: _list}, {headers: this.getHeaders()});
	}

	rfrRefProduitFilter(_picId: any, _tsfId: any, _forTreeView: any = false) {
		return this.http.post(environment.ElmCtrl.rfrRefProduitFilter, {
			picId: _picId,
			tsfId: _tsfId,
			forTreeView: _forTreeView
		}, {headers: this.getHeaders()});
	}

	dmgModernisationDupli(_listRecopy: any) {
		return this.http.post(environment.ElmCtrl.dmgModernisationDupli, {list: _listRecopy}, {headers: this.getHeaders()});
	}

	// ==> Pour la gestion du mobilier de cuisine
	simulationGetCuisineMtoGet(_picId: number, _scaId: number) {
		return this.http.get(environment.sinCtrl.simulationGetCuisineMtoGet
				.replace("{PIC_ID}", _picId.toString())
				.replace("{SCA_ID}", _scaId.toString()),
			{headers: this.getHeaders()});
	}

	simulationGetCuisineMtoSet(_picId: number, _scaId: number, mto: any) {
		return this.http.post(environment.sinCtrl.simulationGetCuisineMtoSet
				.replace("{PIC_ID}", _picId.toString())
				.replace("{SCA_ID}", _scaId.toString()),
			mto,
			{headers: this.getHeaders()});
	}

	// ==> Récupération des données d'un précédent dossier
	getBatimentSimulation(_simId: number) {
		return this.http.get(environment.sinCtrl.getBatimentSimulationById
				.replace("{SIM_ID}", _simId.toString()),
			{headers: this.getHeaders()});
	}

	// ==> Génération du PDF
	generatePdf(_simId: number) {
		return this.http.get(environment.filesCtrl.getPdfFileSimulationById
				.replace("{SIM_ID}", _simId.toString()),
			{headers: this.getHeaders(), responseType: 'blob'});
	}

	// ==> Envoi par email du PDF
	sendMailPdf(_simId: number) {
		return this.http.get(environment.sinCtrl.sendMailPdfGetById
				.replace("{SIM_ID}", _simId.toString()),
			{headers: this.getHeaders()});
	}

	getEvaluationEnergy(_simId: number) {
		return this.http.get(environment.sinCtrl.getEvaluationEnergy
				.replace("{SIM_ID}", _simId.toString()),
			{headers: this.getHeaders()});
	}

	setParamsEnergetiques(_scenarios: any[], _simId: number) {

		return this.http.post(environment.sinCtrl.setParamsEnergetiques
				.replace("{SIM_ID}", _simId.toString()),
			{list: _scenarios},
			{headers: this.getHeaders()});
	}

	getParamsEnergetiques(_simId: number) {
		return this.http.get(environment.sinCtrl.getParamsEnergetiques
				.replace("{SIM_ID}", _simId.toString()),
			{headers: this.getHeaders()});
	}

	// ==> Stripe
	getAllStripeProducts() {
		return this.http.get(environment.stripeCtrl.getAllProducts, {headers: this.getHeaders()});
	}

	getProductByRefId(refId: number) {
		return this.http.get(environment.stripeCtrl.getProductByRefId + "?refId=" + refId, {headers: this.getHeaders()});
	}

	runStripeCheckoutProcess(_productId: string, _priceId: string) {
		return this.http.post(environment.stripeCtrl.checkoutSessionHandler, {
			productId: _productId,
			priceId: _priceId
		}, {headers: this.getHeaders()});
	}

	changeKtvTransationStatus(_traUuid: string, _traStatus: string) {
		return this.http.post(environment.stripeCtrl.changeKtvTransationStatus, {
			transactionUuid: _traUuid,
			transactionStatus: _traStatus
		}, {headers: this.getHeaders()});
	}

	cancelSubscriptionById(_subId: string) {
		return this.http.post(environment.stripeCtrl.cancelSubscriptionById, {
			SubscriptionId: _subId
		}, {headers: this.getHeaders()});
	}

	getFirstSubscription() {
		return this.http.get(environment.stripeCtrl.getFirstSubscription, {headers: this.getHeaders()});
	}

	// ==> Envoi des devis aux partenaires
	sendMailPdfPartners(_list: any, _simId: number) {
		return this.http.post(environment.sinCtrl.sendMailPdfPartners.replace("{SIM_ID}", _simId.toString()), {
			list: _list
		}, {headers: this.getHeaders()});
	}

	isSuperAdmin() {
		return this.http.get(environment.usrCtrl.isSuperAdmin, {headers: this.getHeaders()});
	}

	getAllUsers(): Observable<UserMinAdmin[]> {
		return this.http.get<UserMinAdmin[]>(environment.usrCtrl.getAllUsers, { headers: this.getHeaders() });
	}
}
